import React from 'react';
import { Col, ContentContainer, Row, Button, Heading, SectionHeader,
    IconNotificationError } from '@snsw-gel/react';
import styles from './AddressError.module.scss';

const AddressErrorPage = () => {

    return (

        <>
            <SectionHeader className={ styles['heading-section'] }
                label='Apply for a NSW Seniors Card or NSW Senior Savers Card '>
                <Heading level={ 1 } >
                    <IconNotificationError className={ styles['error-icon'] }/>
                     You are not eligible
                </Heading>
            </SectionHeader>

            <ContentContainer className={ styles['content-container'] }>
                <Row>
                    <Col span={ 12 }>
                        <p>Unfortunately you are not eligible to apply for a Seniors Card as your address is not within Australia.</p>
                    </Col>
                </Row>

                <Button
                    className={ styles['eligibility-button'] }
                    variant='primary'
                    aria-label='Check eligibility guidelines'
                    onClick={ ()=>window.location.href='https://www.service.nsw.gov.au/transaction/apply-for-a-nsw-seniors-card-or-nsw-senior-savers-card#eligibility' }
                >
                       Check eligibility guidelines
                </Button>
                <Button
                    className={ styles['home-button'] }
                    variant='secondary'
                    aria-label='Go to Service New South Wales homepage'
                    onClick={ ()=>window.location.href='https://www.service.nsw.gov.au/' }>Go to Service NSW homepage
                </Button>

            </ContentContainer>
        </>
    );

};
export default AddressErrorPage;
